<template>
  <div>
    <ul v-if="columns">
      <li class="check-tag " v-for="column in columns" :key="column">
        <div :class="selected.indexOf(column) >= 0 ? 'is-primary' : ''">
          <input type="checkbox" :id="'field_' + column" v-model="selected" :value="column" />
          <label :for="'field_' + column">{{ column | toString }}</label>
        </div>
      </li>
      <li class="not-shown" v-for="i in 10" :key="i" />
    </ul>
    <button class="button" @click="selected = columns">Select all</button>
    <button class="button is-black" @click="selected = []">Reset</button>
    <button class="button is-primary" @click="closeModal()">Save</button>
  </div>
</template>

<script>
export default {
  name: 'custom-colums',
  props: ['columns', 'previousSelected'],
  data () {
    return {
      selected: []
    }
  },
  mounted () {
    this.selected = this.previousSelected || []
  },
  filters: {
    toString: function (value) {
      if (value) {
        return value.replace(/_/g, ' ')
      }
      return ''
    }
  },
  watch: {
    previousSelected: function (newVal, oldVal) {
      this.selected = newVal || []
    }
  },
  computed: {
  },
  methods: {
    closeModal () {
      this.selected = this.selected.sort((a, b) => {
        return this.columns.indexOf(a) - this.columns.indexOf(b)
      })
      this.$emit('close', this.selected)
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-container {
  overflow: hidden;
  min-height: initial;
  max-width: initial;
}

ul {
  border: 1px #d3d3d3 solid;
  padding: .8em 0;
  margin: 1em 0;
  flex-wrap: wrap;
  display: flex;

  input[type="checkbox"] {
    display: none;
  }

  li {
    flex-grow: 1;
    flex-shrink: 0;
    width: 30em;
    height: 2.5em;

    //display: inline-block;
    //width:100%;
    // width:250px;
  }

  .not-shown {
    height: 0;
  }
}

.check-tag {
  div {
    font-size: 1.2em;
    transition: .2s;
    border-radius: .3em;
    border: 1px lightgray solid;
    padding: .1em .5em;
    margin: 0.1em 0.3em;

    label {
      cursor: pointer;
      width: 100%;
      display: inline-block;
    }

    text-transform: capitalize;

    &:hover {
      opacity: .9;
    }

    &.is-primary {
      border-color: turquoise;
      color: white;

    }
  }
}</style>


// WEBPACK FOOTER //
// src/components/CustomColumns.vue